export default __webpack_public_path__ + "static/media/trendRise.89701344.svg";